<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="ahalf1" title="Half Title">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii">TOPOPHRENIA<span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253037695_Halftitle_1.vue?c105247c